import "./TheSound.module.css";
import Header from "@/reusable_sections/Header";
import VibrantPortfolios from "./sections/VibrantPortfolios";
import TheFreshnessFactor from "./sections/TheFreshnessFactor";
import Footer from "@/reusable_sections/Footer";
export default function TheSoundPage() {
  return <div>
      <Header />
      <VibrantPortfolios />
      <TheFreshnessFactor />
      <Footer />
    </div>;
}